<script setup lang="ts">
withDefaults(defineProps<{
  label?: string
  modelValue?: string
  placeholder?: string
  options: { value: string; label: string }[]
  required?: boolean
  disabled?: boolean
  error?: string
}>(), {
  placeholder: 'Selecione...',
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

function onChange(e: Event) {
  const target = e.target as HTMLSelectElement
  emit('update:modelValue', target.value)
}
</script>

<template>
  <div>
    <label v-if="label" class="label" :for="label">
      {{ label }}
      <span v-if="required" class="text-red-500 ml-0.5">*</span>
    </label>
    <select
      :id="label"
      :value="modelValue"
      :required="required"
      :disabled="disabled"
      @change="onChange"
      :class="['select', { 'input-error': error }]"
    >
      <option value="" disabled>{{ placeholder }}</option>
      <option v-for="opt in options" :key="opt.value" :value="opt.value">
        {{ opt.label }}
      </option>
    </select>
    <p v-if="error" class="mt-1.5 text-xs text-red-500">{{ error }}</p>
  </div>
</template>
